// @flow
import type { AxiosPromise, AxiosInstance } from "axios";
import debug from "../helpers/debug";

const deletePaymentMethod = (
  id: number
): ((apiInstance: AxiosInstance) => AxiosPromise<>) => (apiInstance) => {
  debug("deletePaymentMethod", id);

  return apiInstance.delete(`/v4/users/payment-methods/${id}/`);
};

export default deletePaymentMethod;
